import {useContext} from "react";
import {Navigate, useLocation} from "react-router-dom";
import {AuthContext} from "../contexts/AuthContext";
import spinner from '../assets/spinner.gif';

const PrivateRoute = ({children}) => {
    const {user, isAuthLoading} = useContext(AuthContext);
    const location = useLocation();

    if (isAuthLoading) {
        return <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'80vh'}}>
            {/*Chargement...*/}
            <img style={{
                width: '64px',
                height: '64px',
                minWidth: '64px',
                minHeight: '64px',
            }} src={spinner} alt=""/>
        </div>;
    }

    if (!user) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    if (user.state === 'notfinished') {
        return <Navigate to="/form" replace />;
    } else if (user.state === 'finished') {
        return <Navigate to="/finished" replace />;
    } else if (user.state === 'archived') {
        return <Navigate to="/archived" replace />;
    }

    return children;
};

export default PrivateRoute;

